'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initLineItemContainers = exports.updateLineItemQuantity = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateLineItemQuantity = exports.updateLineItemQuantity = function updateLineItemQuantity(data) {
  var change = 'QUANTITY';
  var container = 'line-item';

  _state2.default.set(Object.assign({}, data, { change: change, container: container }));
};

var getLineItemContainerData = function getLineItemContainerData() {
  return $(_Dom2.default.lineItemContainer).get().map(function (lineItemContainer) {
    var id = lineItemContainer.dataset.containerId;

    var _JSON$parse = JSON.parse($(lineItemContainer).find(_Dom2.default.lineItemData).text()),
        data = _JSON$parse.data;

    var key = data.key,
        properties = data.properties,
        _data$variant = data.variant,
        _data$variant$variant = _data$variant.variant,
        variantId = _data$variant$variant.id,
        price = _data$variant$variant.price,
        compare_at_price = _data$variant$variant.compare_at_price,
        inventory = _data$variant.inventory;

    var quantity = parseInt($(lineItemContainer).find(_Dom2.default.quantityValue).val(), 10);
    return {
      _data: data,
      id: id,
      change: 'LINE_ITEM',
      container: 'line-item',
      key: key,
      properties: properties,
      variantId: variantId,
      quantity: quantity,
      inventory: inventory,
      price: price,
      compare_at_price: compare_at_price
    };
  });
};

var initLineItemContainers = exports.initLineItemContainers = function initLineItemContainers(data) {
  _state2.default.clear('line-item');
  return getLineItemContainerData().map(function (item) {
    return _state2.default.set(item);
  });
};